import { BitkitEmptyState, IconBuild } from '@bitrise/bitkit-v2';

import { StreamingBuildLog } from '../StreamingBuildLog/StreamingBuildLog';
import { StructuredBuildLog } from '../StructuredBuildLog/StructuredBuildLog';
import BuildLogErrorBoundary from './BuildLogErrorBoundary';

export type BuildLogContainerProps = {
  showStructuredBuildLog: boolean;
  isLoading: boolean;
};

const BuildLogContainer = ({ isLoading, showStructuredBuildLog }: BuildLogContainerProps) => {
  if (isLoading) {
    return (
      <BitkitEmptyState
        loading
        icon={IconBuild}
        headingText="Waiting for build logs"
        bodyText="The logs of your build will appear here"
      />
    );
  }

  return (
    <BuildLogErrorBoundary>
      {showStructuredBuildLog ? <StructuredBuildLog /> : <StreamingBuildLog />}
    </BuildLogErrorBoundary>
  );
};

export default BuildLogContainer;
